// Tutor classes & subjects configuration

export const TUTOR_CLASSES = [
  "Nursery",
  "KG",
  "Class 1",
  "Class 2",
  "Class 3",
  "Class 4",
  "Class 5",
  "Class 6",
  "Class 7",
  "Class 8",
  "Class 9",
  "Class 10",
  "Class 11",
  "Class 12",
];

export const SUBJECTS_6_10 = [
  "English",
  "French",
  "German",
  "Hindi",
  "Math",
  "Punjabi",
  "Sanskrit",
  "Science",
  "Social Studies",
  "Spanish",
  "Urdu",
].sort((a, b) => a.localeCompare(b));

export const SUBJECTS_11_12 = [
  "Account",
  "Biology",
  "Business Studies",
  "Chemistry",
  "Civics",
  "Economics",
  "English",
  "French",
  "Geography",
  "German",
  "Hindi",
  "History",
  "Math",
  "Physics",
  "Political Science",
  "Punjabi",
  "Sanskrit",
  "Spanish",
  "Urdu",
].sort((a, b) => a.localeCompare(b));

const PRIMARY_CLASSES = new Set([
  "Nursery",
  "KG",
  "Class 1",
  "Class 2",
  "Class 3",
  "Class 4",
  "Class 5",
]);
const SECONDARY_CLASSES = new Set([
  "Class 6",
  "Class 7",
  "Class 8",
  "Class 9",
  "Class 10",
]);
const SENIOR_CLASSES = new Set(["Class 11", "Class 12"]);

export const needsSubjects = (cls) => !PRIMARY_CLASSES.has(cls);

export const getSubjectsForClass = (cls) => {
  if (SECONDARY_CLASSES.has(cls)) return SUBJECTS_6_10;
  if (SENIOR_CLASSES.has(cls)) return SUBJECTS_11_12;
  return [];
};

// All subjects (union) for partner profile setup
export const ALL_TUTOR_SUBJECTS = Array.from(
  new Set([...SUBJECTS_6_10, ...SUBJECTS_11_12]),
);

export const TUTOR_SERVICE_ID = "svc-home-tutor";
